<template>
  <div style="position: relative;width: 100vw;height: 100vh;">
    <div ref="mainView" class="mainPanel bg-white">
      <keep-alive v-if="shouldKeepAlive">
        <router-view @menu="chooseMenu" @openChat="chatOpen" @proChat="productChat" />
      </keep-alive>
      <router-view v-else @menu="chooseMenu" @openChat="chatOpen" @proChat="productChat"/>
      <div v-show="newMsg" @click="toChat('2')" class="py-1 px-4 absolute bg-white border shadow rounded-full flex items-center" style="top: 50%;left: calc(50% - 90px);">
        <svg t="1757665424902" class="icon mr-2" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="8482" width="36" height="36"><path d="M955.665867 816.561595H284.150555c-15.38203 0-27.858054-12.472024-27.858054-27.858055 0-15.38603 12.474024-27.858054 27.858054-27.858054h671.515312c6.962014 0 12.622025-6.770013 12.622024-15.090029V278.242543c0-8.320016-5.660011-15.090029-12.622024-15.090029H324.630634c-6.962014 0-12.622025 6.770013-12.622025 15.090029v335.652656c0 15.38603-12.474024 27.858054-27.858054 27.858054-15.38203 0-27.858054-12.472024-27.858054-27.858054V278.242543c0-39.042076 30.65606-70.804138 68.336133-70.804138H955.661867c37.680074 0 68.336133 31.762062 68.336133 70.804138v467.510914c0.004 39.044076-30.65206 70.808138-68.332133 70.808138z" fill="#2D527C" p-id="8483"></path><path d="M284.150555 278.242543c0 13.708027 6.170012 26.596052 16.606032 34.682068l339.394663 262.986514 339.394663-262.986514c10.43602-8.086016 16.606032-20.970041 16.606033-34.682068 0-23.720046-18.124035-42.948084-40.480079-42.948083h-631.041233c-22.356044 0.002-40.480079 19.230038-40.480079 42.948083z" fill="#CEE8FA" p-id="8484"></path><path d="M640.14725 603.769179c-6.020012 0-12.040024-1.948004-17.062033-5.836011L283.690554 334.946654c-17.154034-13.294026-27.398054-34.490067-27.398053-56.700111 0-39.042076 30.65606-70.804138 68.336133-70.804138H955.661867c37.680074 0 68.336133 31.762062 68.336133 70.804138 0 22.210043-10.24402 43.408085-27.400054 56.700111L657.209284 597.933168a27.806054 27.806054 0 0 1-17.062034 5.836011zM324.630634 263.152514c-6.958014 0-12.622025 6.770013-12.622025 15.090029 0 5.11001 2.170004 9.842019 5.808012 12.662025l322.330629 249.766488 322.32863-249.766488c3.638007-2.820006 5.810011-7.552015 5.810011-12.662025 0-8.320016-5.664011-15.090029-12.622024-15.090029H324.630634z" fill="#2D527C" p-id="8485"></path><path d="M281.36255 390.340762H27.858054C12.474024 390.340762 0 377.868738 0 362.484708s12.474024-27.858054 27.858054-27.858054h253.504496c15.38203 0 27.858054 12.472024 27.858054 27.858054s-12.476024 27.856054-27.858054 27.856054zM281.36255 517.09101H111.438218c-15.38203 0-27.858054-12.472024-27.858055-27.858054s12.474024-27.858054 27.858055-27.858055h169.924332c15.38203 0 27.858054 12.472024 27.858054 27.858055s-12.476024 27.858054-27.858054 27.858054zM281.36255 643.843258H195.018381c-15.38203 0-27.858054-12.472024-27.858055-27.858055s12.474024-27.858054 27.858055-27.858054h86.344169c15.38203 0 27.858054 12.472024 27.858054 27.858054s-12.476024 27.858054-27.858054 27.858055z" fill="#2D527C" p-id="8486"></path></svg>
        <div>New Message</div>
      </div>
      <ChatPage ref="chatpanel" v-show="showChat" @messages="newMessage"></ChatPage>
    </div>
    <div v-show="isvisited != '0'" class="tabbar shadow-default">
      <!-- <div class="flex justify-between">
        <div class="w-1/4">
          <router-link :to="{ name: 'home' }" class="barItem">
            <img v-show="isvisited == '1'" src="../assets/action/acttree.png" style="width: 24px;height: 24px;" alt="">
            <img v-show="isvisited != '1'" src="../assets/action/tree.png" style="width: 24px;height: 24px;" alt="">
            <div :class="[isvisited == '1' ? 'text-orange' : 'text-black']">Home</div>
          </router-link>
        </div>
        <div class="w-1/4">
          <router-link :to="{ name: 'chat' }" class="barItem">
            <img v-show="isvisited == '2'" src="../assets/action/actdear.png" style="width: 24px;height: 24px;" alt="">
            <img v-show="isvisited != '2'" src="../assets/action/dear.png" style="width: 24px;height: 24px;" alt="">
            <div :class="[isvisited == '2' ? 'text-orange' : 'text-black']">Chat</div>
          </router-link>
        </div>
        <div class="w-1/4">
          <router-link :to="{ name: 'cart' }" class="barItem">
            <img v-show="isvisited == '3'" src="../assets/action/actgife.png" style="width: 24px;height: 24px;" alt="">
            <img v-show="isvisited != '3'" src="../assets/action/gife.png" style="width: 24px;height: 24px;" alt="">
            <div :class="[isvisited == '3' ? 'text-orange' : 'text-black']">Cart</div>
          </router-link>
        </div>
        <div class="w-1/4">
          <router-link :to="{ name: istoken?'account':'login' }" class="barItem">
            <img v-show="isvisited == '4'" src="../assets/action/actpeople.png" style="width: 24px;height: 24px;" alt="">
            <img v-show="isvisited != '4'" src="../assets/action/people.png" style="width: 24px;height: 24px;" alt="">
            <div :class="[isvisited == '4' ? 'text-orange' : 'text-black']">My</div>
          </router-link>
        </div>
      </div> -->
      
      <div class="flex justify-between">
        <div class="w-1/5">
          <div @click="toChat('1')" class="barItem">
            <!-- <img v-show="isvisited == '1' && !showChat" src="../assets/home.png" style="width: 24px;height: 24px;" alt="">
            <img v-show="isvisited != '1' || showChat" src="../assets/home-fill.png" style="width: 24px;height: 24px;" alt="">
            <div :class="[isvisited == '1' && !showChat ? 'text-orange' : 'text-black']">Home</div> -->
            <img src="../assets/1688.svg" style="width: 34px;height: 34px;" alt="">
          </div>
        </div>
        <!-- <div class="w-1/5">
          <div @click="toChat('5')" class="barItem">
            <img v-show="isvisited == '5' && !showChat" src="../assets/freight.png" style="width: 24px;height: 24px;padding: 2px;" alt="">
            <img v-show="isvisited != '5' || showChat" src="../assets/freight-fill.png" style="width: 24px;height: 24px;padding: 2px;" alt="">
            <div :class="[isvisited == '5' && !showChat ? 'text-orange' : 'text-black']">Freight</div>
          </div>
        </div> -->
        <div class="w-1/5">
          <div @click="toChat('6')" class="barItem">
            <img v-show="isvisited == '6' && !showChat" src="../assets/category.png" style="width: 24px;height: 24px;padding: 2px;" alt="">
            <img v-show="isvisited != '6' || showChat" src="../assets/category-fill.png" style="width: 24px;height: 24px;padding: 2px;" alt="">
            <div :class="[isvisited == '6' && !showChat ? 'text-orange' : 'text-black']">Categories</div>
          </div>
        </div>
        <div class="w-1/5">
          <div @click="toChat('2')" class="barItem relative">
            <img v-show="showChat" src="../assets/chat.png" style="width: 24px;height: 24px;" alt="">
            <img v-show="!showChat" src="../assets/chat-fill.png" style="width: 24px;height: 24px;" alt="">
            <div :class="[showChat ? 'text-orange' : 'text-black']">Chat</div>
            <div v-show="newPoint" class="absolute top-0 w-2.5 h-2.5 rounded-full bg-red-500" style="left: 60%;"></div>
          </div>
        </div>
        <div class="w-1/5">
          <div @click="toChat('3')" class="barItem">
            <img v-show="isvisited == '3' && !showChat" src="../assets/cart.png" style="width: 24px;height: 24px;" alt="">
            <img v-show="isvisited != '3' || showChat" src="../assets/cart-fill.png" style="width: 24px;height: 24px;" alt="">
            <div :class="[isvisited == '3' && !showChat ? 'text-orange' : 'text-black']">Cart</div>
          </div>
        </div>
        <div class="w-1/5">
          <div @click="toChat('4')" class="barItem">
            <img v-show="isvisited == '4' && !showChat" src="../assets/account.png" style="width: 24px;height: 24px;padding: 2px;" alt="">
            <img v-show="isvisited != '4' || showChat" src="../assets/account-fill.png" style="width: 24px;height: 24px;padding: 2px;" alt="">
            <div :class="[isvisited == '4' && !showChat ? 'text-orange' : 'text-black']">My</div>
          </div>
        </div>
      </div>
      <!-- <div class="flex justify-between">
        <div class="w-1/4">
          <div @click="toChat('1')" class="barItem">
            <img v-show="isvisited == '1' && !showChat" src="../assets/home.png" style="width: 24px;height: 24px;" alt="">
            <img v-show="isvisited != '1' || showChat" src="../assets/home-fill.png" style="width: 24px;height: 24px;" alt="">
            <div :class="[isvisited == '1' && !showChat ? 'text-orange' : 'text-black']">Home</div>
          </div>
        </div>
        <div class="w-1/4">
          <div @click="toChat('2')" class="barItem relative">
            <img v-show="showChat" src="../assets/chat.png" style="width: 24px;height: 24px;" alt="">
            <img v-show="!showChat" src="../assets/chat-fill.png" style="width: 24px;height: 24px;" alt="">
            <div :class="[showChat ? 'text-orange' : 'text-black']">Chat</div>
            <div v-show="newPoint" class="absolute top-0 w-2.5 h-2.5 rounded-full bg-red-500" style="left: 60%;"></div>
          </div>
        </div>
        <div class="w-1/4">
          <div @click="toChat('3')" class="barItem">
            <img v-show="isvisited == '3' && !showChat" src="../assets/cart.png" style="width: 24px;height: 24px;" alt="">
            <img v-show="isvisited != '3' || showChat" src="../assets/cart-fill.png" style="width: 24px;height: 24px;" alt="">
            <div :class="[isvisited == '3' && !showChat ? 'text-orange' : 'text-black']">Cart</div>
          </div>
        </div>
        <div class="w-1/4">
          <div @click="toChat('4')" class="barItem">
            <img v-show="isvisited == '4' && !showChat" src="../assets/account.png" style="width: 24px;height: 24px;padding: 2px;" alt="">
            <img v-show="isvisited != '4' || showChat" src="../assets/account-fill.png" style="width: 24px;height: 24px;padding: 2px;" alt="">
            <div :class="[isvisited == '4' && !showChat ? 'text-orange' : 'text-black']">My</div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
  import {
    createCoupons,
    getNotice,
    setNotice,
    getId
  } from '@/api/user'
  import uaParser from 'ua-parser-js'
  import ChatPage from './gpt/index.vue'
  export default {
    components: {
      ChatPage
    },
    data() {
      return {
        isvisited: '',
        chatShow: false,
        manage: {},
        chatNum: 0,
        istoken: false,
        websocket: '',
        manageNew: {},
        ruleForm: [],
        userID: 0,
        t: null,
        noticeList: [],
        noRead: 0,
        firstLogin: 0,
        times: '',
        email: '',
        head_portrait: '',
        userName: '',
        superLevel: '',
        firstName: '',
        price_status: '0',
        nologinHello: [],
        chatMessage: [],
        entering: false,
        newNotice: null,
        chatPanel: false,
        emojiPanel: false,
        emojiList: [
          '🙂','😁','😂','😊','😍','😐',
          '😕','😒','😢','😭','🎉','❤',
          '👌','👍','🙏','✊','✌','✋',
        ],
        msg: '',
        startPos: 0,
        endPos: 0,
        bookingChat: false,
        bookingName: '',
        portChat: false,
        portName: '',
        orderChat: false,
        orderName: '',
        fileType: 1,
        shouldKeepAlive: false,
        newMsg: false,
        showChat: false,
        newPoint: false,
        chatProduct: false,
        shopId: 0,
        source: 1,
      }
    },
    created() {
      this.updateKeepAlive();
    },
    beforeRouteUpdate(to, from, next) {
      this.updateKeepAlive(to);
      next();
    },
    mounted(){
      if(this.$store.state.user.token){
        this.istoken = true
      }else{
        this.istoken = false
      }
      // this.StartWebSocket()
      if(this.istoken){
        let dt = new Date()
        const userId = JSON.parse(localStorage.getItem('userId'))
        const headImg = JSON.parse(localStorage.getItem('userImg'))
        this.head_portrait = headImg + userId + '_40_40.png?v=' + dt.getTime()
        this.times = dt.getTime()
        let user = JSON.parse(localStorage.getItem('userInfo'))
        this.email = user.email
        this.userName = user.first_name + ' ' + user.last_name
        this.userID = user.id
        this.superLevel = user.super_level
        this.firstLogin = user.first_login
        this.firstName = user.first_name
        if(user.hasOwnProperty('manage')){
          this.manage = user.manage
          if(this.manage.whatsappp.indexOf('+')==-1){
            this.manage.whatsappp = '+86'+ this.manage.whatsappp
          }
        }
        this.price_status = user.price_status
      }else{
        if(localStorage.getItem('chat_info')){
          let chatInfo = JSON.parse(localStorage.getItem('chat_info'))
          this.manageNew = chatInfo.manage
          this.manage = chatInfo.manage
          if(this.manage.whatsappp.indexOf('+')==-1){
            this.manage.whatsappp = '+86'+ this.manage.whatsappp
          }
          localStorage.setItem("manageNew", JSON.stringify(this.manageNew))
          this.ruleForm.id = chatInfo.chat_id
        }else{
          // let code = localStorage.getItem('invitation_code')
          // getId({
          //   type: 1,
          //   code: code
          // }).then(res=>{
          //   localStorage.setItem('chat_info',JSON.stringify(res.data))
          //   this.manageNew = res.data.manage
          //   this.manage = res.data.manage
          //   localStorage.setItem("manageNew", JSON.stringify(this.manageNew))
          //   if(this.manage.whatsappp.indexOf('+')==-1){
          //     this.manage.whatsappp = '+86'+ this.manage.whatsappp
          //   }
          //   this.ruleForm.id = res.data.chat_id
          // })
        }
        const ua = uaParser(navigator.userAgent)
        this.ruleForm.browser = ua.browser.name
        this.ruleForm.sys = ua.os.name + ua.os.version
        this.ruleForm.machine = window.screen.width + '*' + window.screen.height

        // this.$refs.memberMask.style = 'display:block;'
        // this.$refs.nologinModal.style = 'display:block;'
        // setTimeout(()=>{
        //   this.$refs.memberMask.style = 'display:block;opacity:1;'
        //   this.$refs.nologinModal.style = 'display:block;opacity:1;--tw-scale-x: 1;--tw-scale-y: 1;'
        // })
      }
      // this.accessNotice()
    },
    destroyed() {
      clearInterval(this.t)
    },
    methods:{
      updateKeepAlive(route = this.$route) {
        this.shouldKeepAlive = route.meta.keepAlive;
        console.log(this.shouldKeepAlive);
      },
      async chooseMenu(e) {
        this.isvisited = await e
        if(this.isvisited == '0'){
          this.$refs.mainView.style.height = '100%'
        }else{
          this.$refs.mainView.style.height = 'calc(100% - 50px)'
        }
      },
      chatOpen(){
        this.$emit('openChat')
      },
      productChat(id, source){
        this.chatProduct = true
        this.shopId = id
        this.source = source
        // this.$notify('提示文案');
        if(this.showChat){
          this.showChat = false
        }else{
          this.toChat('2')
        }
      },
      StartWebSocket() {
        this.websocket = new WebSocket("wss://chat.co-logistics.cn/wss")
        // this.websocket = new WebSocket("wss://testchat.co-logistics.com/wss")
        this.websocket.onopen = this.onOpen;
        this.websocket.onclose = this.onClose;
        this.websocket.onmessage = this.onMessage;
        this.websocket.onerror = this.onError;
      },
      onOpen(e) {
        if(this.istoken){
          var me_1 = {
            type: "init",
            from_user_id: this.userID,
            service_type: 1,
            status: "",
            order_state: this.$store.state.user.token,
          }
          this.websocket.send(JSON.stringify(me_1))
        }else{
          this.nologinMessage()
        }
      },
      onClose() {
        this.StartWebSocket()
      },
      onMessage(e) {
        var data = JSON.parse(e.data)

      },
      onError(){
        this.StartWebSocket()
      },
      nologinMessage(){
        let code = localStorage.getItem('invitation_code')
        var message = {
          type: "no_login_init",
          sys: this.ruleForm.sys,
          browser: this.ruleForm.browser,
          machine: this.ruleForm.machine,
          from_user_id: this.ruleForm.id,
          code: code,
          manage: this.manageNew,
          order_state: this.$store.state.user.token,
        }
        this.websocket.send(JSON.stringify(message))
      },
      toChat(type){
        if(type == '1'){
          this.showChat = false
          this.$router.push({name:'home'})
        }else if(type == '2'){
          this.newMsg = false
          this.newPoint = false
          this.showChat = true
          this.$refs.chatpanel.Height()
          if(this.chatProduct){
            let productItem = {
              shopId: this.shopId,
              psource: this.source,
            }
            localStorage.setItem("askProduct", JSON.stringify(productItem))
          }
          //   this.$router.push({
          //     name: 'chat',
          //     params: {
          //       shopId: this.shopId,
          //       psource: this.source,
          //     },
          //   })
          // }else{
            this.$router.push({name:'chat'})
          // }
        }else if(type == '3'){
          this.showChat = false
          this.$router.push({name:'cart'})
        }else if(type == '4'){
          this.showChat = false
          if(this.istoken){
            this.$router.push({name:'account'})
          }else{
            this.$router.push({name:'login'})
          }
        }else if(type == '5'){
          this.showChat = false
          this.$router.push({name:'parcelPrice'})
        }else{
          this.showChat = false
          this.$router.push({name:'allcategories'})
        }
      },
      newMessage(msg){
        if(msg){
          if(!this.showChat){
            this.newMsg = true
            this.newPoint = true
            setTimeout(()=>{
              this.newMsg = false
            },2000)
          }
        }else{
          this.showChat = false
        }
      }
    },
  };
</script>

<style lang="postcss" scoped>
  .mainPanel{
    @apply relative w-full min-h-full;
  }

  .tabbar{
    padding: 6px 0 0;
    width: 100%;
    height: 50px;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: #fff;
    z-index: 60;
    user-select: none;
  }

  .barItem{
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 12px;
  }
</style>
